import React from 'react'
import style from "./Category.module.css"
const Category = ({handleChange, categoricalBudget}) => {
  return (
    <>
    <div className={style.subCategory}>
        <label htmlFor="food">Food</label>
        <input type="number" name="food" id="food" value={categoricalBudget.food} onChange={handleChange} />
    </div>
    <div className={style.subCategory}>
        <label htmlFor="travel">Travel</label>
        <input type="number" name="travel" id="travel" value={categoricalBudget.travel} onChange={handleChange}/>
    </div>
    <div className={style.subCategory}>
        <label htmlFor="entertainment">Entertainment</label>
        <input type="number" name="entertainment" id="entertainment" value={categoricalBudget.entertainment} onChange={handleChange}/>
    </div>
    </>
  )
}

export default Category